import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

import { PositionEnum, SdButtonComponent, SdThemeComponent } from '@seb/web-design-system/core';
import { ISiblingCategory } from './sibling-categories.interface';

@Component({
  selector: 'sd-sibling-categories',
  templateUrl: './sibling-categories.component.html',
  styleUrls: ['./sibling-categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdButtonComponent,
    RouterLink,
    NgClass
  ]
})
export class SdSiblingCategoriesComponent extends SdThemeComponent {
  siblingCategories = input<ISiblingCategory[]>([]);
  currentCategoryName = input<string>('');
  siblingCategoryIsClicked = output<ISiblingCategory>();
  positionEnum = PositionEnum;

  onClickSiblingCategory(siblingCategory: ISiblingCategory): void {
    this.siblingCategoryIsClicked.emit(siblingCategory);
  }
}
